import { MIGRATIONS, NOME_BANCO, SCHEMA_VERSION } from './schema.js';

let conexaoAberta = null;
let aberturaEmCurso = null;

export async function lerVersao(conexao) {
    const resultado = await conexao.query('PRAGMA user_version');
    const linha = resultado?.values?.[0];
    if (!linha) return 0;
    const valor = linha.user_version ?? Object.values(linha)[0];
    return Number(valor) || 0;
}

export async function aplicarMigrations(conexao, migrations = MIGRATIONS) {
    const versaoAtual = await lerVersao(conexao);
    const pendentes = migrations
        .filter((m) => m.toVersion > versaoAtual)
        .sort((a, b) => a.toVersion - b.toVersion);

    for (const migration of pendentes) {
        for (const statement of migration.statements) {
            await conexao.execute(statement);
        }
        await conexao.execute(`PRAGMA user_version = ${Number(migration.toVersion)}`);
    }

    return pendentes.length ? pendentes[pendentes.length - 1].toVersion : versaoAtual;
}

export async function abrirBanco({ driver, nome = NOME_BANCO }) {
    if (conexaoAberta) return conexaoAberta;
    if (aberturaEmCurso) return aberturaEmCurso;

    aberturaEmCurso = (async () => {
        if (driver.preparar) await driver.preparar();
        const conexao = await driver.abrir(nome);
        await aplicarMigrations(conexao);
        conexaoAberta = conexao;
        return conexao;
    })();

    try {
        return await aberturaEmCurso;
    } catch (erro) {
        conexaoAberta = null;
        throw erro;
    } finally {
        aberturaEmCurso = null;
    }
}

export async function fecharBanco() {
    if (!conexaoAberta) return;
    const conexao = conexaoAberta;
    conexaoAberta = null;
    await conexao.close();
}

export function conexaoAtual() {
    return conexaoAberta;
}

export { SCHEMA_VERSION };
